import { useAuthStore } from '@/modules/auth/store/auth';
import { storeToRefs } from 'pinia';

export default defineNuxtRouteMiddleware(async (to) => {
  const authStore = useAuthStore();
  const { data, getSession } = useAuth();
  const { user, hasLoggedInUser, isDriver } = storeToRefs(authStore);

  if (!hasLoggedInUser.value) {
    await getSession();

    if (data.value?.data) {
      user.value = data.value.data as typeof user.value;
    }
  }

  if (!hasLoggedInUser.value) {
    return navigateTo({
      path: '/driver',
      query: {
        redirect: to.fullPath,
      },
    });
  }

  if (!isDriver.value) {
    return navigateTo('/');
  }
});
